import React from 'react'

import LeftCard from './Main/LeftCard'
import MainCarousel from './Main/MainCarousel'
import SubCarousel from './Main/SubCarousel'
import MiddleLine from './Main/MiddleLine'

import { Container } from 'react-bootstrap';
import Pattern from 'style/whitepattern.png'

import db from 'service/db'

function Main() {
    const [noticeArr, setNoticeArr] = React.useState([])
    const [articleArr, setArticleArr] = React.useState([])
    const [matchArr, setMatchArr] = React.useState([])
    const [coachArr, setCoachArr] = React.useState([])
    const [refereeArr, setRefereeArr] = React.useState([])
    const [mainbanner, setMainbanner] = React.useState([])
    const [subbanner, setSubbanner] = React.useState([])

    React.useEffect(() => {
        Promise.all([db.getAllDb('notice'),
        db.getAllDb('article'),
        db.getAllDb('matchschedule'),
        db.getAllDb('coachnotice'),
        db.getAllDb('refereenotice'),
        db.getImagesByCategory('main'),
        db.getImagesByCategory('sub'),
        ]).then(result => {
            setNoticeArr(result[0].filter((item, idx) => idx < 5));
            setArticleArr(result[1].filter((item, idx) => idx < 5));
            setMatchArr(result[2].filter((item, idx) => idx < 5));
            setCoachArr(result[3].filter((item, idx) => idx < 5));
            setRefereeArr(result[4].filter((item, idx) => idx < 5));
            setMainbanner(result[5]);
            setSubbanner(result[6])

        })
    }, [])

    return (
        <div >
            <div className="d-none d-xl-block container">
                <MainCarousel imgArr={mainbanner} />
            </div>
            <MiddleLine />
            <div style={{ background: `url(${Pattern})`, backgroundRepeat: "repeat" }}>
                <Container>
                    <div className="d-none d-xl-flex " style={{ display: "flex", height: "100%", width: "100%" }}>
                        <div style={{ width: "50%" }}>
                            <div style={{ height: "50%", background: `rgb(185,185,185)` }}>
                                <LeftCard root="notice" title="공지사항" postArr={noticeArr} />
                            </div>
                            <div style={{ height: "50%", background: `rgb(215,215,215)` }}>
                                <LeftCard root="article" title="보도자료" postArr={articleArr} />
                            </div>
                        </div>
                        <div style={{ width: "50%" }}>
                            <SubCarousel imgArr={subbanner} show={false} />
                        </div>
                    </div>
                </Container>
            </div>
            <div className="d-xl-none">
                <MainCarousel imgArr={mainbanner} />
                <LeftCard root="matchschedule" postArr={matchArr} title="대회일정" />
                <LeftCard root="coachnotice" postArr={coachArr} title="코치과정공지" />
                <LeftCard root="refereenotice" postArr={refereeArr} title="심판과정공지" />
            </div>
        </div>
    );
}

export default Main;
